import { useDispatch } from 'react-redux';
import { showSnackbar } from '../Reducer/SnackbarReducer';
import { validateRequired } from '../util';

export const useSchemaValidation = () => {
  const dispatch = useDispatch();

  const validateRequiredWithMessage = (rows, schema) => {
    const result = validateRequired(rows, schema);

    if (!result.valid) {
      const fields = schema?.fields ? schema.fields : schema || {};
      const meta = fields[result.field];

      dispatch(
        showSnackbar({
          message:
            meta?.message || `${meta?.label || '필수값'} 을(를) 입력하세요.`,
          type: meta?.type || 'warning',
        })
      );
      return false;
    }
    return true;
  };

  return { validateRequiredWithMessage };
};
